import { render } from "./WarehouseCategories.vue?vue&type=template&id=8431ca2e&scoped=true"
import script from "./WarehouseCategories.vue?vue&type=script&lang=js"
export * from "./WarehouseCategories.vue?vue&type=script&lang=js"

import "./WarehouseCategories.vue?vue&type=style&index=0&id=8431ca2e&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8431ca2e"]])

export default __exports__